import React from 'react';

const LikeIcon = (props) => {
    if (props.user.like) {
        return (<i className="fas fa-thumbs-up fa-lg"></i>);
    } else {
        return (<i className="fal fa-thumbs-up fa-lg"></i>);
       }
}
export default LikeIcon;